import { apiGet } from './client';
import type { Environment } from './users';

/** `GET /api/v1/admin`: what build the server runs and in which environment. */
export interface AdminStatus {
  version: string;
  commitSha: string;
  buildTime: string;
  environment: Environment;
}

/** Fetches the Admin page's data. The server answers 403 without `VIEW_ADMIN`. */
export function getAdminStatus(): Promise<AdminStatus> {
  return apiGet<AdminStatus>('/admin');
}
